import {createApi} from "@reduxjs/toolkit/query/react";
import {axiosBaseQuery} from "@/helpers/axiosBaseQuery";
import api from "@/store/api/api";

export const tipsApi = createApi({
    reducerPath: 'tipsApi',
    tagTypes: ['tips', 'tip-configs'],
    baseQuery: axiosBaseQuery({
        baseUrl: api.root,
    }),
    endpoints: build => ({
        getTips: build.query({
            query: ({ queryOptions, ...params }) => ({
                url: api.tips.getTips(),
                method: 'GET',
                params,
            }),
            serializeQueryArgs: ({ endpointName, queryArgs }) => {
                return [endpointName, queryArgs?.location_id]
            },
            merge: (currentCache, newItems, { arg }) => {
                if (arg.skip === 0 || arg.all) {
                    return newItems;
                }
                currentCache.push(...newItems.filter((newItem) => !currentCache.some((item) => item.id === newItem.id)))
            },
            forceRefetch: ({ currentArg, previousArg }) => {
                return currentArg !== previousArg;
            },
            providesTags: ['tips']
        }),
        getTipConfigs: build.query({
            query: ({ queryOptions, ...params }) => ({
                url: api.tips.getTipConfigs(),
                method: 'GET',
                params,
            }),
            serializeQueryArgs: ({ endpointName, queryArgs }) => {
                return [endpointName, queryArgs?.location_id]
            },
            merge: (currentCache, newItems, { arg }) => {
                if (arg.skip === 0 || arg.all) {
                    return newItems;
                }
                currentCache.push(...newItems.filter((newItem) => !currentCache.some((item) => item.id === newItem.id)))
            },
            forceRefetch: ({ currentArg, previousArg }) => {
                return currentArg !== previousArg;
            },
            providesTags: ['tip-configs']
        }),
        setTipConfigs: build.mutation({
            query: ({id, ...data}) => {
                return {
                    url: api.tips.setTipConfig(),
                    method: 'POST',
                    body: data
                }
            },
            async onQueryStarted(patch, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(
                        tipsApi.util.updateQueryData('getTipConfigs', {location_id: patch.location_id}, (draft) => {
                            const itemIndex = draft?.findIndex(item => item.id === patch.id);
                            if (itemIndex !== -1) {
                                draft[itemIndex] = {
                                    ...draft[itemIndex],
                                    ...data
                                };
                            } else {
                                draft.push(data)
                            }
                        })
                    )
                } catch (error) {
                    console.error('Failed to update cache:', error)
                }
            },
        }),
        requestPayout: build.mutation({
            query: ({staff_id, ...data}) => {
                return {
                    url: api.tips.requestPayout(staff_id),
                    method: 'POST',
                    body: data
                }
            },
            async onQueryStarted(patch, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(
                        tipsApi.util.updateQueryData('getTips', {location_id: patch.location_id}, (draft) => {
                            draft.forEach((item, index) => {
                                if (!item.payout_id) {
                                    draft[index] = {
                                        ...item,
                                        payout_id: data.id,
                                        payout: data,
                                    }
                                }
                            })
                        })
                    )
                } catch (error) {
                    console.error('Failed to update cache:', error)
                }
            },
        }),
        getPayoutPreview: build.query({
            query: ({ id, ...params }) => ({
                url: api.tips.payoutPreview(id),
                method: 'GET',
                params,
            }),
        }),
    })
})

export const { useGetTipsQuery, useLazyGetTipsQuery, useGetPayoutPreviewQuery, useRequestPayoutMutation } = tipsApi
